<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${this.$t("site")}` : this.$t("site");
    },
  },
  mounted() {
    // 在浏览器环境中检查URL参数（OAuth回调）
    // 使用 mounted 确保路由已经初始化
    if (typeof window !== 'undefined' && window.location) {
      const urlParams = new URLSearchParams(window.location.search);
      const uid = urlParams.get('uid');
      const token = urlParams.get('token');
      const error = urlParams.get('error');
      
      if (error) {
        // 如果有错误，跳转到登录页面显示错误
        this.$message({
          message: '登录失败: ' + error,
          type: 'error',
        });
        // 清除URL中的参数
        if (window.history && window.location) {
          window.history.replaceState({}, document.title, '/login');
        }
        if (this.$router) {
          this.$router.push('/login');
        }
      } else if (uid && token) {
        // 如果从OAuth回调返回，保存用户信息到localStorage
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem("user", uid);
          localStorage.setItem("access_token", token);
          
          // 清除URL中的参数
          if (window.history && window.location) {
            window.history.replaceState({}, document.title, window.location.pathname);
          }
          
          // 使用 nextTick 确保路由已准备好，然后跳转到首页
          this.$nextTick(() => {
            if (this.$router && this.$route) {
              // 如果当前在登录页面或首页，确保跳转到首页
              if (this.$route.name === 'login' || this.$route.path === '/') {
                this.$router.push({ name: "home" }).catch(err => {
                  // 忽略导航重复的错误
                  if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                  }
                });
              }
            }
          });
        }
      }
    }
  }
};
</script>